<template>
  <div class="not-found-view d-flex flex-column align-items-center justify-content-center min-vh-100 p-4">
    <h1 class="display-4 text-muted">404</h1>
    <p class="lead text-center">Halaman tidak ditemukan.</p>
    <p class="text-center text-muted small">
      Akses aplikasi melalui link yang diberikan (berisi token dan opsional nomor meja).
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
};
</script>
